// extracted by mini-css-extract-plugin
module.exports = {"idwalLogo":"HoldingPage_idwalLogo__17D-9","holding":"HoldingPage_holding__9NOA1","verifying":"HoldingPage_verifying__DEwqb","failed":"HoldingPage_failed__2zq8m"};